import { AddressOfBuilding } from './address-of-building.model';
import { Address } from './address.model';
import { BuildingModel } from './building.model';
import { ContractPerson } from './contract-person.model';
import { ControlClassification } from './control-classification.enum';
import { ControlReason } from './control-reason.enum';
import { ControlType } from './control-type.enum';
import { OwnerPartner } from './owner-partner.model';
import { PreventionSubClassificationType } from './prevention-sub-classification-type.enum';
import { WorkOrderState } from './work-order-state.enum';
import { WorkType } from './work-type.enum';

export interface WorkOrder {
  workType: WorkType;
  identifier: string;
  state: WorkOrderState;
  district: string;
  issuedTo: string;
  contactPerson: ContractPerson;
  externalPlotNumber: string;
  externalBuildingNumbers: string[];
  externalBuildingNumber: string;
  addresses: Address[];
  buildings: BuildingModel[];
  addressOfBuilding: AddressOfBuilding;
  preferredAppointmentDate: Date;
  documents: string[];
  controlAcceptanceNumber: string;
  internalControlAcceptanceNumber: string;
  controlReason: ControlReason;
  controlType: ControlType;
  projectNumber: string;
  created: Date;
  owner: string;
  ownerPartner: OwnerPartner;
  controlClassification: ControlClassification;
  preventionSubClassificationType: PreventionSubClassificationType;
}
